import { getNumber } from '@pbk/get-number';
const BASE_REM_TO_PX = 16;
export const numberToRem = (value) => {
    return `${value}rem`;
};
export const numberToPx = (value) => {
    return `${value}px`;
};
export const pxToRem = (px) => {
    const remValue = px / BASE_REM_TO_PX;
    return numberToRem(remValue);
};
const remValueRegex = /^\d+(\.\d+)?/;
export const remToNumber = (rem) => {
    const matchedNumber = rem.match(remValueRegex)?.[0];
    return getNumber(matchedNumber);
};
export const remToPx = (rem) => {
    const remNumber = remToNumber(rem);
    return numberToPx(remNumber * BASE_REM_TO_PX);
};
export const isRem = (value) => {
    return value.endsWith('rem');
};
